import { useState } from 'react';
import { Button } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconEye } from '@tabler/icons-react';

import { TechnicalPlanTableButton } from '../../../-components/technical-plan-table/technical-plan-table-button';
import { RouterOutput, trpc } from '../../../../../../../services/trpc';

export function TechnicalPlanTableSection({
  project,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
}) {
  const { mutateAsync: previewTechnicalPlanTable } =
    trpc.documents.previewTechnicalPlanTable.useMutation();
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return (
    <>
      <TechnicalPlanTableButton
        projectId={project.id}
        technicalPlanTable={project.technicalPlanTable}
        label={
          project.technicalPlanTable
            ? 'Modifier le tableau'
            : 'Remplir le tableau'
        }
      />
      {project.technicalPlanTable && (
        <Button
          loading={isPreviewLoading}
          variant="outline"
          leftSection={<IconEye size={16} />}
          onClick={async () => {
            setIsPreviewLoading(true);
            try {
              if (!project.technicalPlanTable) {
                showNotification({
                  title: 'Tableau non rempli',
                  message: "Veuillez remplir le tableau avant de l'afficher",
                  color: 'red',
                });
                return;
              }

              const { buffer } = await previewTechnicalPlanTable(
                { projectId: project.id },
                {},
              );

              const url = URL.createObjectURL(
                new Blob([buffer], { type: 'application/pdf' }),
              );
              window.open(url, '_blank');
            } finally {
              setIsPreviewLoading(false);
            }
          }}
        >
          Aperçu tableau
        </Button>
      )}
    </>
  );
}
